// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import '@styles/webdesktop/stylesheets/toggleButton.scss';
import React from 'react';
import { SvgIcon } from '../SvgIcon/SvgIcon';
import { Size } from '@front/sharedcomponents/Variables';
import { ToggleButtonTypeClass } from './ToggleButtonType';
export const ToggleButton = (_a) => {
    var { text, icon, type, size = Size.None, checked = false, disabled = false, className, onClick } = _a, restProps = __rest(_a, ["text", "icon", "type", "size", "checked", "disabled", "className", "onClick"]);
    const toggleButtonClassNames = [
        'toggle-button',
        ToggleButtonTypeClass[type],
        className,
        size === Size.None ? '' : size,
        checked ? ' selected' : ''
    ];
    const toggleButtonClassName = toggleButtonClassNames.filter(Boolean).join(' ');
    return (React.createElement("button", Object.assign({ className: toggleButtonClassName, onClick: onClick, disabled: disabled }, restProps),
        !isNullOrUndefined(icon) && React.createElement(SvgIcon, { icon: icon, size: size }),
        isValidString(text) && React.createElement("span", { className: "toggle-button-text" }, text)));
};
